/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState, useEffect, useRef, Fragment } from 'react';
// import Logger from '../Logger';
import { connect } from 'react-redux';
import { withRoomContext } from '../../RoomContext';
import * as settingsActions from '../../store/actions/settingsActions';
import * as meActions from '../../store/actions/meActions';

import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import randomString from 'random-string';
import { useLocation } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { store } from '../../store/store';
import { Popover, Switch } from '@material-ui/core';
import './styles.css';
import CustomLoader from '../Loader/customLoader';
import * as roomActions from '../../store/actions/roomActions';
import InputDeviceAccess from '../inputDeviceAccess';
import InfoIcon from '@material-ui/icons/Info';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import ChromaKey from '../../matting';
import OopsPopup from '../popups/oopsPopup/oopsPopup';
import GradientButton from '../customMui/newButton/newButton';
import StopRoundedIcon from '@material-ui/icons/StopRounded';
import { ToastContainer, toast } from 'react-toastify';
import deviceInfo from '../../deviceInfo';
import { styled } from '@material-ui/core/styles';
import { shouldMirrorLocalWebcamCss } from '../../utils/localWebcamCssMirror';

const VideoPreview = ({
	roomClient,
	room,
	mediaPerms,
	displayName,
	// displayNameInProgress,
	picture,
	// loggedIn,
	changeDisplayName,
	setMediaPerms,
	// classes,
	setAudioMuted,
	setVideoMuted,
	// locale,
	// localesList,
	// templateWaitingRoomUrl,
	// volume,
	// noiseThreshold,
	webcamDevices,
	audioDevices,
	setSelectedWebcamDevice,
	setSelectedAudioDevice,
	onToggleMirrorOwnVideo,
	mirrorOwnVideo,
	// brandingImageLogo,
	recordMode,
	setInVideoAccesble,
	isVideoAccessble,
	browser,
	// setIsLanguageDropdown,
	// isChangeLanguageDropdown,
	isAudioAccessble,
	setInAudioAccesble,
	setJoinDailogStreams,
	setPermissionRelaodPopUp,
	permissionReloadPopUp,
	setVirtualBgDetails,
	s3VirtualBGImages,
	virtualBg,
	// overRoomLimit,
	closeRoomFull,
	isMobile,
	isTablet,
	changeDisplayEmail,
	displayEmail,
	setEmailInMe
}) =>
{

	const virtualBgArray = [
		{ id: 1, src: 'office-1.jpg', alt: 'office' },
		{ id: 2, src: 'office-2.jpg', alt: 'office' },
		{ id: 3, src: 'office-3.jpg', alt: 'office' },
		{ id: 4, src: 'office-4.jpg', alt: 'office' },
		{ id: 5, src: 'office-5.jpg', alt: 'office' },
		{ id: 6, src: 'office-6.jpg', alt: 'office' },
		{ id: 7, src: 'office-7.jpg', alt: 'office' },
		{ id: 8, src: 'office-8.jpg', alt: 'office' },
		{ id: 9, src: 'solid-1.jpg', alt: 'solid' },
		{ id: 10, src: 'solid-2.jpg', alt: 'solid' },
		{ id: 11, src: 'solid-3.jpg', alt: 'solid' },
		{ id: 12, src: 'solid-4.jpg', alt: 'solid' },
		{ id: 13, src: 'solid-5.jpg', alt: 'solid' },
		{ id: 14, src: 'solid-6.jpg', alt: 'solid' },
		{ id: 15, src: 'solid-7.jpg', alt: 'solid' },
		{ id: 16, src: 'solid-8.jpg', alt: 'solid' }
	];

	const location = useLocation();
	const devices = deviceInfo();
	const intl = useIntl();

	const [ anchorElMicrophone, setAnchorElMicrophone ] = useState(null);
	const [ anchorElCamera, setAnchorElCamera ] = useState(null);
	const [ mediaStream, setMediaStream ] = useState(new MediaStream());
	const [ selectedAudioName, setSelectedAudioName ] = useState('');
	const [ selectedVideoName, setSelectedVideoName ] = useState('');
	const [ playSound, setPlaySound ] = useState(false);
	const [ joining, setJoining ] = useState(false);
	const roomId = decodeURIComponent(location.pathname.slice(1)) || randomString({ length: 8 }).toLowerCase();

	const [ meetingInfo, setMeetingInfo ] = useState({});
	const [ infoOpen, setInfoOpen ] = useState(false);
	const deviceData = deviceInfo();

	const videoRef = useRef(null);
	const audio = useRef(undefined);
	const video = useRef(undefined);
	const baseVideoStream = useRef(null);
	const infoRef = useRef(undefined);

	const [ videoButtonDisabe, setVideoButtonDisable ] = useState(false);
	const [ audioButtonDisabe, setAudioButtonDisable ] = useState(false);
    const [selectedBackground, setSelectedBackground] = useState(null);
	const [ newChromakey, setChromaKey ] = useState(null);

	const [ permissionHandler, setPermissionHandler ] = useState({
		audio : false,
		video : false
	});

	const openMicrophone = Boolean(anchorElMicrophone);
	const openCamera = Boolean(anchorElCamera);

	const CustomSwitch = styled(Switch)(({ theme }) => ({
		'& .MuiSwitch-thumb': {
		  backgroundColor: 'var(--primaryColor)',
		},
		'& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
		  backgroundColor: 'var(--primaryColor)',
		},
		'& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
		  backgroundColor: 'var(--primaryColor)',
		},
	  }));

	const idMicrophone = openMicrophone ? 'microphone-select' : undefined;
	const idCamera = openCamera ? 'camera-select' : undefined;

	let _uid;

	try
	{
		_uid = atob(sessionStorage.getItem('uid'));
	}
	catch (err)
	{
		_uid = sessionStorage.getItem('uid');
	}
	// const [ error, setError ] = useState(false);
	// const [ nameError, setNameError ] = useState(false);
	// const [ emailError, setEmailError ] = useState(false);
	const [ error, setError ] = useState({ nameError: false, emailError: false });

	let webcams;

	if (webcamDevices)
		webcams = Object.values(webcamDevices);
	else
		webcams = [];

	let audioDevicesList;

	if (audioDevices)
	{
		audioDevicesList = Object.values(audioDevices);
	}
	else
		audioDevicesList = [];

	const Clickout = (eve) =>
	{
		if (infoRef.current?.contains(eve.target))
		{
			return;
		}
		setInfoOpen(false);
	};

	useEffect(() =>
	{
		document.addEventListener('mousedown', Clickout);

		setMediaPerms(
			{
				...mediaPerms,
				audio : true,
				video : true
			}
		);

		const getMeeting = async () =>
		{
			const meetingData = await roomClient.getMeetingInfo();

			console.log('meetingData===', meetingData);
			const endTime = (meetingData?.iat) + (meetingData?.meetingDetails?.duration * 60000);

			setMeetingInfo({
				meetingName : meetingData?.meetingDetails?.meetingName,
				hostUid     : meetingData?.meetingDetails?.hostUid,
				startTime   : new Date(meetingData?.iat).toLocaleDateString('en-IN', { day    : 'numeric',
					month  : 'short',
					year   : 'numeric',
					hour   : '2-digit',
					minute : '2-digit',
					hour12 : true
				})
					.split('/')
					.join(' '),
				endTime : new Date(endTime).toLocaleDateString('en-IN', { day    : 'numeric',
					month  : 'short',
					year   : 'numeric',
					hour   : '2-digit',
					minute : '2-digit',
					hour12 : true
				})
					.split('/')
					.join(' ')
			});
			(deviceData.platform === 'desktop' && deviceData.name === 'electron' && handleJoin());
		};

		getMeeting();

		return () =>
		{
			document.removeEventListener('mousedown', Clickout);

			if (mediaStream !== null || mediaStream !== undefined)
			{
				mediaStream?.getTracks().forEach((track) =>
				{
					if (track.kind === 'audio')
					{
						track.enabled = false;
					}
					track.stop();
				});
			}
		};

	}, []);

	useEffect(() =>
	{
		if (_uid !== 'guest' && room.inLobby)
		{
			roomClient.changeDisplayEmail(_uid);
		}
	}, [ _uid ]);

	const handleClose = () =>
	{

		console.log('fkjgfsf');
		setAnchorElMicrophone(null);
		setAnchorElCamera(null);
	};

	const displayVideo = (track, kind) =>
	{
		const ms = mediaStream;

		ms.getTracks().forEach((each) =>
		{
			if (each?.kind === kind)
			{
				each.stop();
				ms.removeTrack(each);
			}
		});
		const videoDOMObj = videoRef.current;
		ms.addTrack(track);
		setMediaStream(ms);
		if (videoDOMObj !== null && kind !== 'audio')
		{
			videoDOMObj.srcObject = ms;
		}
		else if (kind !== 'audio')
		{
			// If video element doesn't exist yet, wait for it to be rendered
			// Use a more reliable approach with requestAnimationFrame
			const waitForVideoElement = () => {
				const videoElement = videoRef.current;
				if (videoElement) {
					videoElement.srcObject = ms;
				} else {
					requestAnimationFrame(waitForVideoElement);
				}
			};
			waitForVideoElement();
		}
	};

	const userMediaVideo = async (constraintsData) =>
	{
		// let localstream = null;
		// const permissionStatus = await navigator.permissions.query({ name: 'camera' });
		try
		{
			if (mediaPerms?.video)
			{
				await navigator.mediaDevices
					.getUserMedia(constraintsData)
					.then((stream) =>
					{
					// localstream = stream;
						roomClient._updateWebcams();
						displayVideo(stream?.getTracks()[0], 'video');
						// stream?.getTracks().forEach((each) =>
						// {
						//  each.stop();
						// });
						setInVideoAccesble(true);
						setPermissionHandler((prevState) => ({
							...prevState,
							video : true
						}));
					})
					.catch((err) =>
					{
						setPermissionHandler((prevState) => ({
							...prevState,
							video : true
						}));
						setMediaPerms(
							{
								...mediaPerms,
								audio : mediaPerms?.audio,
								video : false
							}
						);

						window.parent.postMessage(JSON.stringify({ cmd: 'JOIN_DIALOG_VIDEO', value: { status: !mediaPerms?.video } }), '*');

						if (err.name === 'NotAllowedError')
						{
							setInVideoAccesble(false);
						}
					});
			}
		}
		catch (err)
		{
			console.log('new_err', err);
		}
	};

	const userMediaAudio = async (constraintsData) =>
	{
		await navigator.mediaDevices
			.getUserMedia(constraintsData)
			.then((stream) =>
			{
				roomClient._updateAudioDevices();
				setPermissionHandler((prevState) => ({
					...prevState,
					audio : true
				}));
				displayVideo(stream?.getTracks()[0], 'audio');
				// stream?.getTracks().forEach((each) =>
				// {
				//  each.stop();
				// });
				setInAudioAccesble(true);
			})
			.catch((err) =>
			{
				setPermissionHandler((prevState) => ({
					...prevState,
					audio : true
				}));
				setMediaPerms(
					{
						...mediaPerms,
						audio : false,
						video : mediaPerms?.video
					}
				);

				window.parent.postMessage(JSON.stringify({ cmd: 'JOIN_DIALOG_AUDIO', value: { status: !mediaPerms?.audio } }), '*');

				if (err.name === 'NotAllowedError')
				{
					setInAudioAccesble(false);
				}
			});
	};

	const getVideo = async (backgroundState) =>
	{
		// setLoader(false);

		if ((selectedBackground?.backgroundImg || selectedBackground?.blur) && mediaPerms.video && backgroundState !== 'remove')
		{
			changeBackground(selectedBackground?.backgroundImg, selectedBackground?.blur);

			return;
		}

		video.current = video.current ? video.current : webcams[0]?.deviceId ? webcams[0]?.deviceId : undefined;

		if (store.getState().settings.mediaPerms.audio && !recordMode)
		{
			const constraints = {
				audio : {
					deviceId : audio ?
						{ exact: audio.current } : undefined,
					echoCancellation : true
				}
			};

			userMediaAudio(constraints);
		}
		if (store.getState().settings.mediaPerms.video && !recordMode)
		{
			const constraints = {
				video : {
					deviceId : video ?
						{ exact: video.current } : undefined
				}
			};

			userMediaVideo(constraints);
		}
	};

	const getAudio = async () =>
	{

		audio.current = audio.current ? audio.current : audioDevicesList[0]?.deviceId ? audioDevicesList[0]?.deviceId : undefined;

		if (store.getState().settings.mediaPerms.audio && !recordMode)
		{
			const constraints = {
				audio : {
					deviceId : audio ?
						{ exact: audio.current } : undefined,
					echoCancellation : true
				}
			};

			userMediaAudio(constraints);
		}
		if (!videoRef?.current?.srcObject)
		{
			if (store.getState().settings.mediaPerms.video && !recordMode)
			{
				const constraints = {
					video : {
						deviceId : video ?
							{ exact: video.current } : undefined
					}

				};

				userMediaVideo(constraints);
			}
		}
	};

	useEffect(() =>
	{
		getAudio();
	}, [ mediaPerms?.audio ]);

	useEffect(() =>
	{
		getVideo();
	}, [ mediaPerms?.video ]);

	// Handle the case where video element becomes available after media stream is set
	useEffect(() => {
		if (mediaPerms?.video && mediaStream && videoRef.current) {
			const videoElement = videoRef.current;
			console.log('Video element available, setting srcObject:', videoElement);
			if (videoElement && !videoElement.srcObject) {
				videoElement.srcObject = mediaStream;
			}
		}
	}, [mediaPerms?.video, mediaStream]);

	useEffect(() =>
	{
		mediaStream?.getTracks().forEach((each) =>
		{
			if (each?.kind === 'video' && each?.readyState === 'ended')
			{
				video.current = undefined;
				getVideo();
				setSelectedWebcamDevice(webcams[0]?.deviceId);
			}
		});
	}, [ webcams.length ]);

	useEffect(() =>
	{
		mediaStream?.getTracks().forEach((each) =>
		{
			if (each?.kind === 'audio' && each?.readyState === 'ended')
			{
				audio.current = undefined;
				getAudio();
				setSelectedAudioDevice(audioDevicesList[0]?.deviceId);
			}
		});
	}, [ audioDevicesList.length ]);

	const handleMirrorVideo = () =>
	{
		onToggleMirrorOwnVideo();
	};

	const handleChangeDisplayName = (event) =>
	{
		const { key } = event;

		switch (key)
		{
			case 'Enter':
			case 'Escape':

			{
				displayName = displayName.trim();

				if (room.inLobby)
					roomClient.changeDisplayName(displayName);
				break;
			}
			default:
				break;
		}
	};
	const isValidEmail = (email) =>
	{
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		return emailRegex.test(email);
	};

	const handleChangeEmail = (event) =>
	{
		const { key } = event;

		switch (key)
		{
			case 'Enter':
			case 'Escape':

			{
				displayEmail =displayEmail.trim();

				if (room.inLobby)
					roomClient.changeDisplayEmail(displayEmail);
				break;
			}
			default:
				break;
		}
	};

	// const handleFocus = (event) => event.target.select();

	const handleFocus = (event) =>
	{
		const fieldName = event.target.id;

		setError((prevError) => ({ ...prevError, [fieldName === 'displayname' ? 'nameError' : 'emailError'] : false
		}));

		event.target.select();
	};

	const validateDisplayName =(name) =>
	{
		// Allow Unicode letters, numbers, spaces, hyphens, apostrophes, and periods
		// This supports international names with accented characters and non-Latin scripts
		const regex = /^[\p{L}\p{N}\s\-'\.]*$/u;

		return regex.test(name);
	};

	async function handleJoin()
	{
		// const nameError = !validateDisplayName(displayName);
		const emailError = !isValidEmail(displayEmail);

		if (emailError)
		{
			setError({ emailError });

			return;
		}

		if (devices?.name === 'firefox')
		{
			await mediaStream?.getTracks().forEach((track) =>
			{
				if (track.kind === 'audio')
				{
					track.enabled = false;
				}
				track.stop();
			});
		}
		setJoinDailogStreams(mediaStream);
		setSelectedWebcamDevice(video.current);
		setSelectedAudioDevice(audio.current);

		setJoining(true);

		setAudioMuted(false);

		setVideoMuted(false);

		// _askForPerms();

		const encodedRoomId = encodeURIComponent(roomId);

		roomClient.join({
			roomId    : encodedRoomId,
			joinVideo : mediaPerms.video,
			joinAudio : mediaPerms.audio
		});

		setEmailInMe(displayEmail);
	}

	const handleChange = async (e, media, device) =>
	{
		const kindsToReplace = media === 'audio' ? [ 'audio' ] : [ 'video' ];

		[ ...mediaStream.getTracks() ].forEach((each) =>
		{
			if (kindsToReplace.includes(each.kind))
			{
				each.stop();
				mediaStream.removeTrack(each);
			}
		});

		if (media === 'video')
		{
			video.current = device?.deviceId;
			setSelectedVideoName(device?.label);
		}
		if (media === 'audio')
		{
			audio.current = device?.deviceId;
			setSelectedAudioName(device?.label);
		}

		handleClose();

		// When a virtual background is active, switching the camera device must
		// rebuild the chroma pipeline against the new device (forceNewPipeline)
		// rather than just swapping the raw camera track.
		const vbActive = !!(selectedBackground?.backgroundImg || selectedBackground?.blur) && mediaPerms?.video;

		if (media === 'video' && vbActive)
		{
			if (newChromakey)
			{
				newChromakey.close();
				setChromaKey(null);
			}
			if (baseVideoStream.current)
			{
				baseVideoStream.current.getTracks().forEach((t) => t.stop());
				baseVideoStream.current = null;
			}
			await changeBackground(
				selectedBackground?.backgroundImg,
				selectedBackground?.blur,
				{ forceNewPipeline: true }
			);
			getAudio();

			return;
		}

		if (media === 'video')
		{
			getVideo();
		}
		getAudio();
	};

	// const changeBackground = async (backgroundImg, blur) =>
	// {
	//  setVirtualBgDetails(backgroundImg, blur);
	//  setSelectedBackground({ backgroundImg, blur });

	//  const stream = await navigator.mediaDevices
	//      .getUserMedia(
	//          { video : {
	//              deviceId : video ?
	//                  { exact: video.current } : undefined
	//          } }
	//      );

	//  const chroma = new ChromaKey();

	//  setChromaKey(chroma);

	//  chroma.doLoad(stream, backgroundImg, blur);
	//  displayVideo(chroma.capStream.getVideoTracks()[0], 'video');
	// };

	async function changeBackground(backgroundImg, blur, { forceNewPipeline = false } = {})
	{
		setVirtualBgDetails(backgroundImg, blur);
		setSelectedBackground({ backgroundImg, blur });

		// Reuse a single base camera stream across background changes to avoid
		// repeated getUserMedia calls while the join dialog is open.
		let stream = baseVideoStream.current;

		if (!stream || stream.getVideoTracks().length === 0)
		{
			stream = await navigator.mediaDevices
				.getUserMedia(
					{
						video : {
							deviceId : video ?
								{ exact: video.current } : undefined
						}
					}
				);

			baseVideoStream.current = stream;
		}

		// If we already have a chroma pipeline for the preview, just update the
		// background/blur. The track from capStream stays the same, so there is
		// no need to call displayVideo again or create a new WebGL context –
		// this avoids black frames and extra GPU usage.
		if (!forceNewPipeline && newChromakey && newChromakey.capStream)
		{
			newChromakey.updateBackground(backgroundImg, blur);

			return;
		}

		const chroma = new ChromaKey();

		setChromaKey(chroma);

		chroma.doLoad(stream, backgroundImg, blur);

		// Wait until the first frame with the virtual background has been
		// rendered before using the track. If we fail to get a first frame
		// (e.g. WebGL/MediaPipe not available), fall back to the plain camera
		// stream instead of showing a black preview.
		let firstFrameOk = true;

		try
		{
			await chroma.waitForFirstFrame();
		}
		catch (err)
		{
			firstFrameOk = false;
		}

		const [ track ] = chroma.capStream.getVideoTracks();

		if (firstFrameOk && track)
		{
			displayVideo(track, 'video');
		}
		else
		{
			const [ fallbackTrack ] = stream.getVideoTracks();

			if (fallbackTrack)
			{
				displayVideo(fallbackTrack, 'video');
			}
		}
	}

	const handleSetMediaPerms = async (event, newMediaPerms) =>
	{
		if (newMediaPerms === 'audio')
		{
			setAudioButtonDisable(true);
			if (!isAudioAccessble)
			{
				setPermissionRelaodPopUp(true);
			}
			else
			{
				setMediaPerms(
					{
						...mediaPerms,
						audio : !mediaPerms?.audio,
						video : mediaPerms?.video
					}
				);
				window.parent.postMessage(JSON.stringify({ cmd: 'JOIN_DIALOG_AUDIO', value: { status: !mediaPerms?.audio } }), '*');
			}

			setTimeout(async () =>
			{
				setAudioButtonDisable(false);
			}, 500);
		}
		if (newMediaPerms === 'video')
		{
			setVideoButtonDisable(true);

			if (!isVideoAccessble)
			{
				setPermissionRelaodPopUp(true);
			}
			else
			{
				setMediaPerms(
					{
						...mediaPerms,
						audio : mediaPerms?.audio,
						video : !mediaPerms?.video
					}
				);
				window.parent.postMessage(JSON.stringify({ cmd: 'JOIN_DIALOG_VIDEO', value: { status: !mediaPerms?.video } }), '*');
			}

			setTimeout(async () =>
			{
				setVideoButtonDisable(false);
			}, 500);

		}
		if (mediaStream)
		{
			mediaStream?.getTracks().forEach((each) =>
			{
				if (each?.kind === 'video' && newMediaPerms === 'video')
				{
					if (!store.getState().settings.mediaPerms.video)
					{
						each.stop();
					}
					if (selectedBackground?.backgroundImg)
					{
						each.stop();
					}
					removeBackGround();
				}
				if (each?.kind === 'audio' && newMediaPerms === 'audio')
				{
					each['enabled'] = !mediaPerms?.audio;
				}
			});
		}
	};

	const removeBackGround = () =>
	{
		if (newChromakey)
		{
			newChromakey.close();
			setChromaKey(null);
		}

		// Stop the dedicated base camera stream used for virtual backgrounds.
		if (baseVideoStream.current)
		{
			baseVideoStream.current.getTracks().forEach((each) => each.stop());
			baseVideoStream.current = null;
		}

		// Stop any tracks currently attached to the preview mediaStream.
		mediaStream.getTracks().forEach((each) => each.stop());

		setVirtualBgDetails('', '');
		setSelectedBackground(null);
		getVideo('remove');
	};

	const uploadS3Image = async (e) =>
	{
		const file = e.target.files[0];

		// if (file.size > 1000000)
		// {
		//  setNotification(
		//      {
		//          type : 'error',
		//          text : intl.formatMessage({
		//              id             : 'virtualBG.file',
		//              defaultMessage : 'File size should be less than 1MB'
		//          })
		//      });
		// }
		// else
		// {
		// const formData = new FormData();

		// formData.append('file', file);

		await roomClient.uploadFileToS3(file, 'public/virtualBackground').then((response) =>
		{
			if (response)
			{

				const bg={
					url : response.url,
					key : response.key
				};

				store.dispatch(roomActions.setS3VirtualBGImages(bg));

				toast.success(intl.formatMessage({ id: 'Image_uploaded_successfully', defaultMessage: 'Image uploaded successfully' }), {
					position : toast.POSITION.TOP_RIGHT
				});
			}
		})
			.catch(() =>
			{
				toast.error(intl.formatMessage({ id: 'something_went_wrong', defaultMessage: 'Something went wrong.' }), {
					position : toast.POSITION.TOP_RIGHT
				});
			});

		// }

	};

	const handleDeleteCustomBg = (each) =>
	{

		if (each.url === virtualBg)
		{

			newChromakey.close();
			removeBackGround();
		}

		roomClient.deleteS3Object(each);
		store.dispatch(roomActions.deleteS3VirtualBGImage(each));
		// store.dispatch(requestActions.notify(
		//  {
		//      text : intl.formatMessage({
		//          id             : 'room.virtualBGError',
		//          defaultMessage : 'Image Deleted successfully'
		//      })
		//  }));
	};

	const handleMeetingInfo = async () =>
	{
		setInfoOpen(!infoOpen);
	};

	// const Clickout = (eve) =>
	// {
	// 	if (infoRef.current?.contains(eve.target))
	// 	{
	// 		return;
	// 	}
	// 	setInfoOpen(false);
	// };

	// useEffect(() =>
	// {
	// 	document.addEventListener('mousedown', Clickout);

	// 	return () =>
	// 	{
	// 		document.removeEventListener('mousedown', Clickout);
	// 	};
	// }, []);

	// window.onload = function()
	// {
	//  setLoader(false);
	// };

	const handleNavigate = () =>
	{
		window.location.href = import.meta.env.VITE_config;
	};

	const getInitials = () =>
	{
		if (displayName)
		{
			const words = displayName.split(' ');

			if (words.length > 1)
			{
				return `${words[0].charAt(0).toUpperCase()}${words[1].charAt(0).toUpperCase()}`;
			}
			else if (words.length === 1)
			{
				return words[0].slice(0, 2).toUpperCase();
			}
		}

		return '';
	};
	const [ imageError, setImageError ] = useState(false);

	const handleImageError = () =>
	{
		setImageError(true);
	};

	return (
		<div className='flexCol aCntr fullH'>
			{
				(deviceData.platform === 'desktop' && deviceData.name === 'electron') ?
					<div className='flexCol fullH jCntr aCntr'>
						<CustomLoader/>
					</div>
					:
					(!(permissionHandler.audio && permissionHandler.video) ?
						<div className='flexCol fullH jCntr aCntr'>
							<CustomLoader/>
						</div>
						:
						<>
							<div className='flexCol fullH vpMainCntnr'>
								<div className='flexRow pdngSM jBtwn alignCntr vpHeader pdngSM'>
									<div className='flexInline vpImgCntnr'>
										<img alt='Logo' src='/images/inmeet1.png' />
									</div>
									<div ref={infoRef} className='flexMinWidthCol aEnd pRel cPdngR'>
										<InfoIcon className='pointer' onClick={handleMeetingInfo}/>
										{
											infoOpen &&
											<div className='flexAutoCol pAbs infoPopover pdngSM brdrRadiusXS'>
												<div className='flexCol'>
													<small className='lTxt'>{intl.formatMessage({ id: 'MeetingName', defaultMessage: 'Meeting Name' })} </small>
													<h4 className='pdngBSM'>{meetingInfo?.meetingName}</h4>
													<small>{meetingInfo?.startTime} - {meetingInfo?.endTime}</small>
												</div>
											</div>
										}

									</div>
								</div>

								<div className='resColRow vpBody'>
									<div className='flexMinWidthCol aCntr jCntr gap16 pdngSM'>
										<div className='flexCol videoCntnrNew brdrRadiusMD'>
											{
												mediaPerms?.video &&
												<Tooltip
													title={intl.formatMessage({ id: 'Mirror_View', defaultMessage: 'Mirror View' })}
													placement='bottom'
													className={mirrorOwnVideo ? 'mirrorTxt active' : 'mirrorTxt inactive'}
													onClick={handleMirrorVideo}
												>
													<IconButton >
														<img src={mirrorOwnVideo ? '/icons/mirrorEnable.svg' : '/icons/mirrorDisable.svg'} alt='avatar' />
													</IconButton>
												</Tooltip>

											}
											{ mediaPerms?.video &&
											<video
												ref={videoRef}
												className={shouldMirrorLocalWebcamCss(mirrorOwnVideo, selectedBackground?.backgroundImg, selectedBackground?.blur) ? 'videoPreviewLeft isMirrored' : 'videoPreviewLeft'}
												autoPlay playsInline muted
											/>}
											{
												(!mediaPerms?.video) ?
													<div className='displayTag' >
														{ picture && picture !== '' && !imageError ?
															<img alt='profile' onError={(e) => { e.target.onerror = null; handleImageError(); }} src={`https://${import.meta.env.VITE_s3Bucket}.s3.${import.meta.env.VITE_s3Region}.amazonaws.com/public/profileImages/${picture}`} />
															:
															<span>{getInitials()}</span>
														}
													</div>
													:
													(!mediaPerms?.video && !displayName) &&
													<div className='flexCol jCntr aCntr fullH pAbs'>
														<div className='flexAutoCol previewAvatarImg'>
															<img src='/images/videoPreviewAvatar.svg' alt='avatar' />
														</div>
													</div>
											}
											{
												mediaPerms?.video && !isMobile && !isTablet &&
												<div className='flexCol aCntr bg'>
													<div className='flexRow virtaulBgCntnr'>
														<Button
															id='noneVBG'
															size='small'
															disableElevation
														>
															<div className='flexAutoRow virtualBg pdngXS' onClick={() => removeBackGround('delete')}>
																<img alt='' src='/images/banners/vc-banners/noneVBG.svg' className='brdrRadiusSM' />
															</div>
														</Button>
														<Button
															id='blurVBG'
															size='small'
															disableElevation
														>
															<div className='flexAutoRow virtualBg pdngXS' onClick={() => changeBackground('office-1.jpg', 'lightBlur')}>
																<img alt='' src='/images/banners/vc-banners/blurVBG.svg' className='brdrRadiusSM' />
															</div>
														</Button>

														{
															virtualBgArray.map((each, index) => (
																<Button
																	id={each?.alt}
																	key={index}
																	size='small'
																	disableElevation
																>
																	<div className='flexAutoRow virtualBg pdngXS' onClick={() => changeBackground(each?.src, '')}>
																		<img alt={each?.alt} src={`/images/banners/vc-banners/${each.src}`} className='brdrRadiusSM' />
																	</div>
																</Button>
															))
														}

														{
															s3VirtualBGImages?.length > 0 &&
															(
																s3VirtualBGImages?.map((each, index) => (
																	<Button
																		key={index}
																		id='customVBG'
																		size='small'
																		disableElevation
																		className='customVBG'
																	>
																		<div className='flexAutoRow virtualBg pdngXS' onClick={() => changeBackground(each?.url, '')}>
																			<img alt='' src={each?.url} className='brdrRadiusSM' />
																		</div>
																		<div className='flexInline cancelBtn' onClick={() => handleDeleteCustomBg(each)}>
																			<img alt='' src='/icons/closeIcon.svg'/>
																		</div>
																	</Button>
																))
															)
														}
														{
															s3VirtualBGImages?.length < 5 &&
															<label className='uploadVBGButton'>
																<input
																	accept='image/x-png,image/jpeg,image/jpg'
																	name='signature'
																	className='uploadVBG'
																	type='file'
																	title=''
																	id='signature'
																	value=''
																	onChange={(e) => uploadS3Image(e)}
																/>
																<div className='flexAutoRow virtualBg pdngXS'>
																	<img alt='' src='/images/banners/vc-banners/addVBG.svg' className='brdrRadiusSM' />
																</div>
															</label>
														}
													</div>
												</div>
											}
										</div>

										<div className='flexCol gap16'>
											<div className='flexRow aCntr '>
												<div className='flexAutoRow' style={{ width: '40%' }}>
													<img alt='mic' src='/icons/mic.svg'/>
													<span className='pdngLSM'>{intl.formatMessage({ id: 'microPhone', defaultMessage: 'Microphone' })}</span>
												</div>
												<div className='flexMinWidthRow aCntr'>
													{
														isAudioAccessble ?
															<div className={`flexMinWidthRow aCntr pointer ${!mediaPerms?.audio && 'disable'}`} onClick={(e) => setAnchorElMicrophone(e.currentTarget)}>
																<>
																	<span className='ellipsisTxt'>{selectedAudioName ? selectedAudioName : audioDevices && audioDevices[Object.keys(audioDevices)[0]]?.label}</span>
																	<span className='flexInline jCntr pdngLMD arrowIcons'>
																		{
																			openMicrophone ?
																				<img alt='' src='/icons/upArrow.svg' />
																				:
																				<img alt='' src='/icons/downArrow.svg' />
																		}
																	</span>
																</>
															</div>
															:
															<span className='flexMinWidthRow aCntr disable'>{intl.formatMessage({ id: 'PermissionsDeniedByBrowser', defaultMessage: 'Permissions denied by Browser' })}</span>
													}
													<Popover
														id={idMicrophone}
														open={openMicrophone}
														anchorEl={anchorElMicrophone}
														onClose={handleClose}
														anchorOrigin={{
															vertical   : 'bottom',
															horizontal : 'left'
														}}
														transformOrigin={{
															vertical   : 'top',
															horizontal : 'left'
														}}
														className='pointer'
													>
														{
															audioDevicesList?.map((each, index) => (
																<div key={index} className='flexCol pdngXS hoverEffect' onClick={(e) => handleChange(e, 'audio', each)}>
																	<span value={each?.deviceId}>{each?.label}</span>
																</div>
															))
														}
													</Popover>
													<span className='flexAutoRow pdngLMD'>
														<CustomSwitch
															checked={mediaPerms?.audio}
															disabled={audioButtonDisabe}
															id='micSwitch'
															color='primary'
															size='small'
															onChange={(e) => handleSetMediaPerms(e, 'audio')}
														/>
													</span>
												</div>
											</div>

											<div className='flexRow aCntr '>
												<div className='flexAutoRow' style={{ width: '40%' }}>
													<img alt='mic' src='/icons/video.svg'/>
													<span className='pdngLSM'>{intl.formatMessage({ id: 'Camera', defaultMessage: 'Camera' })}</span>
												</div>
												<div className='flexMinWidthRow aCntr jBtwn'>
													{
														isVideoAccessble ?
															<div className={`flexMinWidthRow aCntr pointer ${!mediaPerms?.video && 'disable'}`} onClick={(e) => setAnchorElCamera(e.currentTarget)}>
																<>
																	<span className='ellipsisTxt'>{selectedVideoName ? selectedVideoName : webcamDevices && Object.values({ ...webcamDevices })[0]?.label}</span>
																	<span className='flexInline jCntr pdngLMD arrowIcons'>
																		{
																			openCamera ?
																				<img alt='' src='/icons/upArrow.svg' />
																				:
																				<img alt='' src='/icons/downArrow.svg' />
																		}
																	</span>
																</>
															</div>
															:
															<span className='flexMinWidthRow aCntr disable'>{intl.formatMessage({ id: 'PermissionsDeniedByBrowser', defaultMessage: 'Permissions denied by Browser' })}</span>
													}
													<Popover
														id={idCamera}
														open={openCamera}
														anchorEl={anchorElCamera}
														onClose={handleClose}
														anchorOrigin={{
															vertical   : 'bottom',
															horizontal : 'left'
														}}
														transformOrigin={{
															vertical   : 'top',
															horizontal : 'left'
														}}
														className='pointer'
													>
														{
															webcams?.map((each, index) => (
																<div key={index} className='flexCol pdngXS hoverEffect' onClick={(e) => handleChange(e, 'video', each)}>
																	<span value={each?.deviceId}>{each?.label}</span>
																</div>
															))
														}
													</Popover>
													<span className='flexAutoRow pdngLMD'>
														<CustomSwitch
															checked={mediaPerms?.video}
															id='camSwitch'
															color='primary'
															size='small'
															disabled={videoButtonDisabe}
															onChange={(e) => handleSetMediaPerms(e, 'video')}
														/>
													</span>
												</div>
											</div>

											<div className='flexRow aCntr '>
												<div className='flexAutoRow' style={{ width: '40%' }}>
													<img alt='mic' src='/icons/speaker.svg'/>
													<span className='pdngLSM'>{intl.formatMessage({ id: 'Speaker', defaultMessage: 'Speaker' })}</span>
												</div>
												<div className='flexMinWidthRow aCntr jBtwn'>
													<div className='flexMinWidthRow aCntr'>
														<span className='ellipsisTxt'>{intl.formatMessage({ id: 'PlaySound', defaultMessage: 'Play Sound' })}</span>
														<span className='flexInline jCntr pdngLMD'>
															<div className='sound-wave'>
																{
																	[ ...Array(30) ].map((each, index) => (
																		<div key={index} className={playSound ? 'barSoundActive' : 'barSoundInactive'} />
																	))
																}
															</div>
														</span>
													</div>
													{playSound &&
													<audio autoPlay>
														<source src='/sounds/welcome.mp3' type='audio/mpeg' />
													</audio>}
													<span className='flexAutoRow pdngLMD'>
														<IconButton size='small' onClick={() => setPlaySound(!playSound)}>
															{
																playSound ?
																	<StopRoundedIcon style={{ color: '#24a4c4', border: '1px solid black', borderRadius: '50%' }}/>
																	:
																	<PlayArrowRoundedIcon style={{ color: 'black', border: '1px solid black', borderRadius: '50%' }}/>
															}
														</IconButton>
													</span>

												</div>
											</div>
										</div>
									</div>
									<div className='flexMinWidthCol jCntr aCntr pdngSM'>
										<div className='flexCol jCntr joinRight brdrRadiusSM'>
											<div className='flexCol jCntr aCntr joinFieldsCntnr'>
												<h3 className='pdngBMD'>{intl.formatMessage({ id: 'ReadyToJoin', defaultMessage: 'Ready to Join ?' })}</h3>
												<TextField
													id='displayname'
													className='displayName'
													label='Name'
													variant='filled'
													// inputProps={{
													// 	maxLength : 30
													// }}
													size='small'
													fullWidth
													value={displayName}
													onChange={(event) =>
													{
														const { value } = event.target;

														if (value.length <= 30)
														{
															// if (validateDisplayName(value))
															// {
															// 	setNameError(false);
															// }
															// else
															// {
															// 	setNameError(true);
															// }
															changeDisplayName(value);
														}
													}}
													onKeyDown={handleChangeDisplayName}
													onFocus={handleFocus}
													error={error?.nameError}
													helperText={error?.nameError ? 'Name should only contain letters, numbers, spaces, hyphens, apostrophes, and periods' : ''}
												/>
												{(_uid === 'guest' || !_uid || _uid !== meetingInfo?.hostUid) &&
												<TextField
													id='displayEmail'
													className='displayName'
													label='Email'
													type='email'
													variant='filled'
													inputProps={{
														maxLength : 100
													}}
													size='small'
													fullWidth
													value={displayEmail}
													onChange={(event) =>
													{
														const { value } = event.target;

														if (value.length <= 100)
														{
															// if (isValidEmail(value))
															// {
															// 	setEmailError(false);
															// }
															// else
															// {
															// 	setEmailError(true);
															// }
															changeDisplayEmail(value);
														}
													}}
													onFocus={handleFocus}
													onKeyDown={handleChangeEmail}
													error={error?.emailError}
													helperText={error?.emailError ? 'Please enter a valid email address.' : ''}
													style={{ marginTop: '1rem' }}
												/>}
												<div className='flexRow mrgnTXLG'>
													<div className='flexMinWidthCol pdngRMD'>
														<Button
															variant='contained'
															// color='disabled'
															id='cancelButton'
															fullWidth
															disableElevation
															onClick={handleNavigate}
															style={{ borderRadius: '10px' }}
														>
															{intl.formatMessage({ id: 'Cancel', defaultMessage: 'Cancel' })}
														</Button>
													</div>
													<div className='flexMinWidthCol'>
														<GradientButton
															variant='contained'
															color='primary'
															id='joinButton'
															fullWidth
															disableElevation
															disabled={displayName === '' || joining || (_uid === 'guest' && displayEmail === '')}
															onClick={handleJoin}
														>
															{intl.formatMessage({ id: 'Join', defaultMessage: 'Join' })}
														</GradientButton>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className='flexCol jCntr alignCntr vpFooter'>
									{/* <small className='vpFooterText' >{intl.formatMessage({ id: 'ByJoiningThisMeetingYouAgreeThatYouAreAbove18YearsOfAgeAgreeToOur', defaultMessage: 'By joining this meeting, you agree that you are above 18 years of age & agree to our' })} <a className='termLinks' href='https://www.instavc.com/privacy-policy/' target='_blank' rel='noreferrer' >{intl.formatMessage({ id: 'PrivacyPolicy', defaultMessage: 'Privacy Policy' })}</a> & <a className='termLinks' href='https://www.instavc.com/terms-and-conditions/' target='_blank' rel='noreferrer' >{intl.formatMessage({ id: 'TermsOfUse', defaultMessage: 'Terms of Use' })}</a></small> */}
									<small className='vpFooterText' >{intl.formatMessage({ id: 'ByusingInMeetyouacceptthe', defaultMessage: 'By using InMeet you accept the' })} <a className='termLinks' href='https://www.instavc.com/terms-and-conditions/' target='_blank' rel='noreferrer' >{intl.formatMessage({ id: 'TermsofService', defaultMessage: 'Terms of Service' })}</a> , <a className='termLinks' href='https://www.instavc.com/privacy-policy/' target='_blank' rel='noreferrer' >{intl.formatMessage({ id: 'PrivacyStatement', defaultMessage: ' Privacy Statement' })}</a>,{intl.formatMessage({ id: 'Notices&Disclaimers', defaultMessage: ' Notices & Disclaimers' })}. {intl.formatMessage({ id: 'LearnmoreaboutInMeet', defaultMessage: ' Learn more about InMeet.' })}</small>
								</div>
							</div>
							{
								permissionReloadPopUp &&
								<InputDeviceAccess
									open={!isVideoAccessble || !isAudioAccessble}
									handleClose={() =>
									{
										setPermissionRelaodPopUp(false);
									}}
									browser={browser}
								/>
							}
							{!room.inLobby && room.overRoomLimit &&
							<OopsPopup handleClose={closeRoomFull}/>
							}
						</>)
			}
			<ToastContainer
				position='top-right'
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnVisibilityChange
				draggable
				pauseOnHover
			/>
		</div>
	);
};

VideoPreview.propTypes =
{
	roomClient               : PropTypes.any.isRequired,
	room                     : PropTypes.object.isRequired,
	roomId                   : PropTypes.string.isRequired,
	displayName              : PropTypes.string.isRequired,
	// displayNameInProgress    : PropTypes.bool.isRequired,
	picture                  : PropTypes.any,
	loginEnabled             : PropTypes.bool.isRequired,
	loggedIn                 : PropTypes.bool.isRequired,
	changeDisplayName        : PropTypes.func.isRequired,
	setMediaPerms            : PropTypes.func.isRequired,
	// classes                  : PropTypes.object,
	mediaPerms               : PropTypes.object.isRequired,
	setAudioMuted            : PropTypes.func.isRequired,
	setVideoMuted            : PropTypes.func.isRequired,
	// locale                   : PropTypes.string.isRequired,
	// localesList              : PropTypes.array.isRequired,
	// templateWaitingRoomUrl   : PropTypes.string,
	// volume                   : PropTypes.number,
	// noiseThreshold           : PropTypes.any,
	webcamDevices            : PropTypes.any,
	audioDevices             : PropTypes.any,
	videoMuted               : PropTypes.bool,
	setSelectedWebcamDevice  : PropTypes.func,
	setSelectedAudioDevice   : PropTypes.func,
	selectedWebcam           : PropTypes.any,
	selectedAudioDevice      : PropTypes.any,
	onToggleMirrorOwnVideo   : PropTypes.func.isRequired,
	mirrorOwnVideo           : PropTypes.bool,
	// brandingImageLogo        : PropTypes.string.isRequired,
	recordMode               : PropTypes.bool,
	setInVideoAccesble       : PropTypes.any,
	isVideoAccessble         : PropTypes.bool,
	browser                  : PropTypes.any,
	// setIsLanguageDropdown    : PropTypes.func,
	// isChangeLanguageDropdown : PropTypes.bool,
	isAudioAccessble         : PropTypes.any,
	setInAudioAccesble       : PropTypes.any,
	setJoinDailogStreams     : PropTypes.any,
	setPermissionRelaodPopUp : PropTypes.any,
	permissionReloadPopUp    : PropTypes.any,
	setVirtualBgDetails      : PropTypes.func,
	s3VirtualBGImages        : PropTypes.array,
	virtualBg                : PropTypes.any,
	closeRoomFull            : PropTypes.func,
	overRoomLimit            : PropTypes.bool,
	isMobile                 : PropTypes.bool,
	isTablet                 : PropTypes.bool,
	changeDisplayEmail       : PropTypes.func.isRequired,
	displayEmail             : PropTypes.string.isRequired,
	setEmailInMe             : PropTypes.any
};

const mapStateToProps = (state, { id }) =>
{
	return {
		room                  : state.room,
		mediaPerms            : state.settings.mediaPerms,
		displayName           : state.settings.displayName,
		// displayNameInProgress    : state.me.displayNameInProgress,
		picture               : state.me.picture,
		loginEnabled          : state.me.loginEnabled,
		loggedIn              : state.me.loggedIn,
		// locale                   : state.intl.locale,
		// localesList              : state.intl.list,
		// templateWaitingRoomUrl   : state.toolarea.templateWaitingRoomUrl,
		// volume                   : state.settings.volume,
		// noiseThreshold           : state.settings.noiseThreshold,
		webcamDevices         : state.me.webcamDevices,
		audioDevices          : state.me.audioDevices,
		videoMuted            : state.settings.videoMuted,
		selectedWebcam        : state.settings.selectedWebcam,
		selectedAudioDevice   : state.settings.selectedAudioDevice,
		mirrorOwnVideo        : state.settings.mirrorOwnVideo,
		// brandingImageLogo        : state.toolarea.brandingImageLogo,
		recordMode            : state.room.recordMode,
		isVideoAccessble      : state.room.isVideoAccessble,
		browser               : state.me.browser,
		// isChangeLanguageDropdown : state.room.isChangeLanguageDropdown,
		isAudioAccessble      : state.room.isAudioAccessble,
		permissionReloadPopUp : state.room.permissionReloadPopUp,
		s3VirtualBGImages     : state.room.s3VirtualBGImages,
		virtualBg             : state.room.virtualBg,
		overRoomLimit         : state.room.overRoomLimit,
		isMobile              : state.me.browser?.platform === 'mobile',
		isTablet              : state.me.browser?.platform === 'tablet',
		displayEmail          : state.settings.displayEmail
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		changeDisplayName : (displayName) =>
		{
			dispatch(settingsActions.setDisplayName(displayName));
		},
		changeDisplayEmail : (displayEmail) =>
		{
			dispatch(settingsActions.setDisplayEmail(displayEmail));
		},
		setMediaPerms : (mediaPerms) =>
		{
			dispatch(settingsActions.setMediaPerms(mediaPerms));
		},
		setAudioMuted : (flag) =>
		{
			dispatch(settingsActions.setAudioMuted(flag));
		},
		setVideoMuted : (flag) =>
		{
			dispatch(settingsActions.setVideoMuted(flag));
		},
		setSelectedWebcamDevice : (selectedVideoDevice) =>
		{
			dispatch(settingsActions.setSelectedWebcamDevice(selectedVideoDevice));
		},
		setSelectedAudioDevice : (selectedAudioDevice) =>
		{
			dispatch(settingsActions.setSelectedAudioDevice(selectedAudioDevice));
		},
		onToggleMirrorOwnVideo : () =>
		{
			dispatch(settingsActions.toggleMirrorOwnVideo());
		},
		setInVideoAccesble : (isVideoAccessble) =>
		{
			dispatch(roomActions.setInVideoAccesble(isVideoAccessble));
		},
		// setIsLanguageDropdown : (isChangeLanguageDropdown) =>
		// {
		// 	dispatch(roomActions.setIsLanguageDropdown(isChangeLanguageDropdown));
		// },
		setInAudioAccesble : (isVideoAccessble) =>
		{
			dispatch(roomActions.setInAudioAccesble(isVideoAccessble));
		},
		setJoinDailogStreams : (joinDailogStreams) =>
		{
			dispatch(roomActions.setJoinDailogStreams(joinDailogStreams));
		},
		setPermissionRelaodPopUp : (permissionReloadPopUp) =>
		{
			dispatch(roomActions.setPermissionRelaodPopUp(permissionReloadPopUp));
		},
		setVirtualBgDetails : (img, blur) =>
		{
			dispatch(roomActions.setVirtualBgDetails(img, blur));
		},
		closeRoomFull : (exit) =>
		{
			dispatch(roomActions.setOverRoomLimit(exit));
		},
		setEmailInMe : (displayEmail) =>
		{
			dispatch(meActions.setMe({	email: displayEmail }));

		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.inLobby === next.room.inLobby &&
                prev.room.signInRequired === next.room.signInRequired &&
                prev.room.overRoomLimit === next.room.overRoomLimit &&
                prev.settings.displayName === next.settings.displayName &&
                prev.settings === next.settings &&
                // prev.me.displayNameInProgress === next.me.displayNameInProgress &&
                prev.me.loginEnabled === next.me.loginEnabled &&
                prev.me.loggedIn === next.me.loggedIn &&
                prev.me.picture === next.me.picture &&
                // prev.intl.locale === next.intl.locale &&
                // prev.intl.localesList === next.intl.localesList &&
                // prev.toolarea.templateWaitingRoomUrl === next.toolarea.templateWaitingRoomUrl &&
                // prev.settings.volume === next.settings.volume &&
                // prev.settings.noiseThreshold === next.settings.noiseThreshold &&
                prev.me.webcamDevices === next.me.webcamDevices &&
                prev.me.audioDevices === next.me.audioDevices &&
                prev.settings.videoMuted === next.settings.videoMuted &&
                prev.settings.setSelectedWebcamDevice === next.settings.setSelectedWebcamDevice &&
                prev.settings.selectedWebcam === next.settings.selectedWebcam &&
                prev.settings.mirrorOwnVideo === next.settings.mirrorOwnVideo &&
                // prev.toolarea.brandingImageLogo === next.toolarea.brandingImageLogo &&
                prev.room.recordMode === next.room.recordMode &&
                prev.me.browser === next.me.browser &&
                prev.room.isVideoAccessble === next.room.isVideoAccessble &&
                // prev.room.isChangeLanguageDropdown === next.room.isChangeLanguageDropdown &&
                prev.room.isAudioAccessble === next.room.isAudioAccessble &&
                prev.settings.mediaPerms === next.settings.mediaPerms &&
                prev.room.permissionReloadPopUp === next.room.permissionReloadPopUp &&
                prev.room.s3VirtualBGImages === next.room.s3VirtualBGImages &&
                prev.room.virtualBg === next.room.virtualBg &&
                prev.me.browser.platfor === next.me.browser.platfor &&
                prev.settings.displayEmail === next.settings.displayEmail

			);
		}
	}
)(VideoPreview));
